<template>
  <div class="header">
    <swiper :options="swiperOption" class="swiper-box">
      <swiper-slide class="swiper-item" v-for="item in images">
        <img :src="item" class="item-img">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script type="text/ecmascript-6">
  import {swiper, swiperSlide} from 'vue-awesome-swiper';
  export default{
    props: {
      images: {
        type: Array
      }
    },
    data() {
      return {
        swiperOption: {
          pagination: '.swiper-pagination',
          slidesPerView: 1,
          paginationClickable: true,
          roundLengths: true,
          autoplay: 3000,
          autoplayDisableOnInteraction: false,
          loop: true,
          effect: 'fade'
        }
      };
    },
    components: {
      swiper,
      swiperSlide
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .header
    width:100%
    .swiper-box
      width:100%
      height:100%
      margin:0 auto
      .swiper-item
        height:100%
        text-align:center
        font-size:18px
        background:#fff
        .item-img
          width:100%
          height:100%
</style>



// WEBPACK FOOTER //
// header.vue?d6f56e4e